// @ts-ignore
import { JsonEditor as Editor } from 'jsoneditor-react';
import { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import env from '../../utils/config';

export function EditFeed() {
  const [json, setJson] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [updateSuccessful, setUpdateSuccessful] = useState(false);
  const [message, setMessage] = useState('');
  const jsonEditorRef = useRef<any>(null);
  const feedUrl = `${env.S3_LOCATION}/${env.FEEDS_FILENAME}`;

  // Fetch json from s3
  useEffect( () => {
    async function fetchJsonFeed() {
      let response = await fetch(feedUrl, {cache: "no-store"});
      response = await response.json();
      setJson(response);
    }
    fetchJsonFeed();
  }, [feedUrl]);

  // Update json when user makes changes to the json editor
  useEffect(() => {
    const editor = jsonEditorRef && jsonEditorRef.current && jsonEditorRef.current.jsonEditor;
    if ( editor && json ) {
      editor.update(json);
      setJson(json);
    }
  }, [json]);

  const deployFeedJson = async () => {
    const feedJsonObj = {
      "feedJson": json
    };
    const response = await fetch(`${env.SERVER_URL}/api/v1/feed/update-entire-feed`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(feedJsonObj)
    });
    if(response.ok) {
      setSubmitted(true);
    }
    const jsonResponse = await response.json();
    if (jsonResponse.message.includes('successfully updated')) {
      setMessage('Please refresh, json successfully updated');
      setUpdateSuccessful(true);
    } else {
      setMessage(`Json not successfully updated, message: ${jsonResponse.message}`)
    }

  }
  return (
    <div className = 'edit-feed-container'>
      <Editor
        ref={jsonEditorRef}
        mode="tree"
        value={json}
        onChange={(json: any) => setJson(json)}
        htmlElementProps={{
          style: {
            height: 500
          },
        }}
      />
      <button className="submit-button" type="submit" onClick={deployFeedJson}>Update Feeds.json</button>
      {
        submitted &&
        <div className={"response-message-div"}>
          {
            updateSuccessful ?
              <>
                <FontAwesomeIcon className="font-awesome-check" size="3x" icon={faCheck} />
                <p className={"success-message"}>{message}</p>
                <br/>
                <p> You may verify it <a href={feedUrl}>here</a> </p>
              </>
              :
              <>
                <FontAwesomeIcon className="font-awesome-cross" size="3x" icon={faXmark} />
                <p className={"error-message"}>{message}</p>
                <br/>
              </>
          }
        </div>
      }
    </div>
  )
}
